import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Loader from '../common/loader';
import '../../common/css/noticeList.css';
import SaveModal from '../modal/saveModal';
import fileImage from '../../common/images/icon/c-attachment.svg';

function NoticeIndex() {
    const [NoticeStatue, setNoticeStatue] = useState('');
    const [NoticeType, setNoticeType] = useState('');
    const [NoticeList, setNoticeList] = useState([]);
    const [isFetched, setIsFetched] = useState(false);
    const [searchData, setSearchData] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [isWait, setIsWait] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [maxPage, setMaxPage] = useState(5);
    const [minPage, setMinPage] = useState(1);

    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);

    const navigate = useNavigate();

    const checkNoticeStatus = () => {
        const path = window.location.pathname.split('/')[2];

        if (path === 'reservationrules') {
            setNoticeType('rule');
            setNoticeStatue('예약/발권 규정');
        } else if (path === 'reissuerules') {
            setNoticeType('reis');
            setNoticeStatue('재발행 규정');
        } else if (path === 'paidseatsbaggagerules') {
            setNoticeType('bag');
            setNoticeStatue('유료좌석/수하물 규정');
        } else if (path === 'cancelrefund') {
            setNoticeType('cxnl');
            setNoticeStatue('취소/환불 규정');
        } else if (path === 'waivercode') {
            setNoticeType('wvrauth');
            setNoticeStatue('환불 웨이버 코드');
        } else if (path === 'Fueltaxinfo') {
            setNoticeType('tax');
            setNoticeStatue('유류 TAX 정보');
        } else if (path === 'Flightdelayinfo') {
            setNoticeType('note');
            setNoticeStatue('운항 (지연/결항 공문)');
        } else if (path === 'etc') {
            setNoticeType('etc');
            setNoticeStatue('기타');
        } else {
            window.location.href = '/';
        }
    };

    const pagnation = () => {
        let result = [];
        if (currentPage == 1 || currentPage == 2) {
            for (let index = minPage; index <= maxPage && index <= totalPage; index++) {
                result.push(
                    <li key={index} className={`${currentPage == index ? 'on' : ''}`}>
                        <a onClick={() => updateURL(index)}>{index}</a>
                    </li>,
                );
            }
        } else {
            let startPage = Math.max(1, currentPage - 2);
            let endPage = Math.min(totalPage, currentPage + 2);
            for (let index = startPage; index <= endPage; index++) {
                result.push(
                    <li key={index} className={`${currentPage == index ? 'on' : ''}`}>
                        <a onClick={() => updateURL(index)}>{index}</a>
                    </li>,
                );
            }
        }
        return result;
    };

    // 페이지 네이션 클래스를 위한 URL 업데이트
    const updateURL = (index) => {
        navigate(`?pageNumber=${index}&search=${searchData}`, { replace: true });
        setCurrentPage(index);
        searchDataResult(index);
    };

    // 이전 및 다음 버튼 클릭 이벤트
    const pagnationBtn = (type) => {
        if (type === 'prev' && currentPage > 1) {
            updateURL(currentPage - 1);

            if (currentPage - 1 < minPage) {
                setMaxPage(maxPage - 1);
                setMinPage(minPage - 1);
            }
        } else if (type === 'next' && currentPage < totalPage) {
            updateURL(currentPage + 1);

            if (currentPage + 1 > maxPage) {
                setMaxPage(maxPage + 1);
                setMinPage(minPage + 1);
            }
        } else {
            alert(type === 'prev' ? '첫번째 페이지입니다.' : '마지막 페이지입니다.');
        }
    };

    // 검색 이벤트
    const searchDataResult = async (pagenumber) => {
        try {
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            const response = await axios.get(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/notice/${NoticeType}?pageNumber=${
                    pagenumber ?? 1
                }&search=${searchData}`,
            );

            setNoticeList(response.data);
            setTotalPage(Math.ceil(response.data.total / 10));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        checkNoticeStatus();
    });

    // 서버통신
    useEffect(() => {
        if (NoticeType !== '') {
            const fetchData = async () => {
                try {
                    const params = new URLSearchParams(window.location.search);
                    const page = params.get('pageNumber') ?? 1;

                    const hostname = window.location.hostname;
                    let isLocal = null;
                    if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                        isLocal = false;
                    } else {
                        isLocal = true;
                    }

                    const response = await axios.get(
                        `${
                            isLocal
                                ? process.env.REACT_APP_PRODUCTION_API_URL
                                : process.env.REACT_APP_LOCAL_API_URL
                        }/wpal/board/notice/${NoticeType}?pageNumber=${page}`,
                    );
                    console.log(response.data);
                    setNoticeList(response.data);
                    setTotalPage(Math.ceil(response.data.total / 10));
                    setCurrentPage(page);
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            };

            if (!isFetched) {
                fetchData();
                setIsFetched(true);
            }
        }
    }, [NoticeType]);

    // 리스트 map 끝나는 순간
    useEffect(() => {
        if (NoticeList?.list && NoticeList.list.length > 0) {
            setIsWait(true);
        }
    }, [NoticeList]);

    return (
        <>
            {!isWait && <Loader list={'true'} />}
            <div
                id='contents'
                className='notice-contents'
                style={{ display: isWait ? '' : 'none' }}
            >
                <div class='subp_h_wrap'>
                    <div class='subp_h_list'>
                        <div class='subp_h_home'></div>
                        <div>공지사항</div>
                        <div>규정안내</div>
                        <div>{NoticeStatue}</div>
                    </div>
                </div>
                <div class='page_hgroup'>
                    <h2 class='title'>{NoticeStatue}</h2>
                    {NoticeType == 'note' ? (
                        <div className='fare-sub-title'>
                            본 메뉴는 한국-필리핀 직항편의 운항 정보가 업데이트 되며, 이 외 구간의
                            경우 필리핀항공 글로벌 사이트 내 Flight status 통해 확인 해주시기
                            바랍니다.
                        </div>
                    ) : (
                        <></>
                    )}
                </div>

                <div class='notice_list_wrap notice_list'>
                    <div class='notice_list'>
                        <div class='list_top_cont'>
                            <p class='pager'>
                                총 <span class='num'>{NoticeList.total}</span>건
                            </p>
                            <div class='search_box notice_search_box'>
                                <input
                                    type='text'
                                    class='search'
                                    placeholder='검색어를 입력하세요'
                                    value={searchData}
                                    onChange={(e) => setSearchData(e.target.value)}
                                />
                                <button
                                    class='button'
                                    onClick={() => {
                                        searchDataResult();
                                    }}
                                />
                            </div>
                        </div>

                        <div class='list_cont'>
                            <ul class='list' style={{ margin: '0px' }}>
                                <li style={{ background: '#E9E9E9' }}>
                                    <a>
                                        <span
                                            style={{
                                                width: '5%',
                                                fontsize: '14px',
                                                fontweight: '700',
                                                color: '#222222',
                                            }}
                                        >
                                            No
                                        </span>
                                        <span
                                            class='txt'
                                            style={{
                                                fontsize: '14px',
                                                textalign: 'center',
                                            }}
                                        >
                                            제목
                                        </span>
                                        <span
                                            class='file'
                                            style={{ width: '10%',textAlign: 'left' }}
                                        >
                                            첨부
                                        </span>
                                        <span
                                            class='date'
                                            style={{ width: '8%', fontsize: '14px' }}
                                        >
                                            등록일
                                        </span>
                                    </a>
                                </li>
                            </ul>

                            {/* 리스트 반복 */}
                            <ul class='list'>
                                {NoticeList?.list?.map((notice, index) => (
                                    <li class='fix' key={index}>
                                        <Link
                                            to={`${window.location.pathname}/detail?idx=${notice.postIdx}`}
                                        >
                                            <span class='ico'>
                                                {notice.isNotice === 'Y' ? '공지' : notice.postIdx}
                                            </span>
                                            <span class='txt' style={{ textAlign: 'left' }}>
                                                {notice.postTitle || ''}
                                            </span>
                                            <span
                                                class={`file ${
                                                    notice.hasFile == 1 ? 'hasFile' : 'noneFile'
                                                }`}
                                                style={{ width: '10%' }}
                                            ></span>
                                            <span class='date' style={{ width: '8%' }}>
                                                {notice.createDate.split(' ')[0]}
                                            </span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div class='pagenation'>
                            <div class='pagenation_inner'>
                                <a
                                    class={`prev_page`}
                                    onClick={() => {
                                        pagnationBtn('prev');
                                    }}
                                >
                                    이전페이지
                                </a>
                                <ul>{pagnation()}</ul>
                                <a
                                    class={`next_page`}
                                    onClick={() => {
                                        pagnationBtn('next');
                                    }}
                                >
                                    다음페이지
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
            </div>
        </>
    );
}

export default NoticeIndex;
